module.exports = __webpack_public_path__ + "static/media/FilledBookMark.54398459.svg";